import ProductRating from './productRating'

export default ProductRating
